import {getPaymentHistoryUrl} from './accounting.helper';

import {getAPICall, postAPICall} from '../../services/apiCallsHandler';
import {paymentHistoryAction} from '../actions/actions';

import {call} from 'redux-saga/effects';

export function* getCompletePaymentHistory(customerId, contractNumber) {
  const response = yield call(
    getAPICall,
    getPaymentHistoryUrl(customerId, contractNumber),
    {
      isCallBack: true,
      contractNumber: contractNumber,
      errorTag: 'GET_PAYMENT_HISTORY',
      logInfoMsg: 'retrieve payment history ',
      redirectToOops: false,
    },
    {
      stateName: 'paymentHistoryData',
      actionName: paymentHistoryAction,
    }
  );

  return {response, contractNumber, customerId};
}
